import { createInjectionKey as e } from "../../_utils/vue/create-injection-key.js";
const t = e("n-popselect");
export {
  t as popselectInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/popselect/src/interface.js
// module id = 929
// module chunks = 41